import { FragmentDefinitionNode, OperationDefinitionNode } from "graphql";

export function isOperationDefinitionNode(
  node: OperationDefinitionNode | FragmentDefinitionNode,
): node is OperationDefinitionNode {
  return node.kind === "OperationDefinition";
}
